import type { RouteParams } from 'types';
// eslint-disable-next-line import/prefer-default-export
export const objToString = (obj: RouteParams): string =>
  Object.keys(obj)
    .map((key) => `${key}_${obj[key]}`)
    .join('_');
